import React, { useEffect, useRef } from 'react';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

export default function StepsNavigation ({fnNext, fnPrevious, labelNext, labelPrevious}) {
	const navigationDivRef = useRef(null);

	if(!labelNext) {
		labelNext = <TextTranslate name="word-next-step" fallback="Next Step"/>
	}
	
	if(!labelPrevious) {
		labelPrevious = <TextTranslate name="word-previous-steps" fallback="Previous Step"/>
	}

	function detectFooter () {
		const footerElement = document.getElementsByTagName('footer')[0];
		if (window.innerHeight - footerElement.getBoundingClientRect().top >= 0) {
			navigationDivRef.current.style.bottom = `${(window.innerHeight - footerElement.getBoundingClientRect().top)}px`;
		} else if (window.innerHeight - footerElement.getBoundingClientRect().top < 0) {
			navigationDivRef.current.style.bottom = 0;
		}
	}

	useEffect(() => {
        window.addEventListener("scroll", detectFooter, true);
        return () => { window.removeEventListener("scroll", detectFooter, true); }
	}, [])
	
	return (
		<div ref={navigationDivRef} className="steps-navigation mt-2 text-right">
			{ fnPrevious ?
				<button
					onClick={fnPrevious}
					className="btn btn-secondary btn-lh-1">
						{labelPrevious}
				</button> : null }
			{ fnNext ?
				<button
					onClick={fnNext}
					className="btn btn-primary btn-lh-1">
						{labelNext}
				</button> : null }
		</div>
	)
}